/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment';
import 'moment/locale/ko';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import {
    deletePAIAB020,
    getPAIAB020Download,
    postPAIAB020Clone,
    postPAIAB020List,
    putPAIAB020JumpUp,
    putPAIAB020Reset,
    putPAIAB020Toggle,
} from '../../../services/Api';
import Loader from '../../../shared/components/Loader';
import Pagination from '../../../shared/components/Pagination';
import SideNav from '../../../shared/components/SideNav';
import { MESSAGE } from '../../../shared/constants/app';
import { formatDate } from '../../../utils';

const PAIAB020 = () => {
    const [data, setData] = useState([]);
    const [pages, setPages] = useState({});
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const navigate = useNavigate();

    const [activePopup, setActivePopup] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await postPAIAB020List({ page });
                setData(data.data);
                setPages(data.info);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, [page]);

    const handleResumeLvl = async (seq, resumeLvl) => {
        const isPublic = resumeLvl === 'Y';
        const confirmMsg = isPublic
            ? '이력서를 비공개로 변경하시겠습니까?'
            : '공개로 변경하면 현재 공개중인 이력서가 있을 경우 비공개로 변경됩니다.\n이력서를 공개로 변경하시겠습니까?';

        if (window.confirm(confirmMsg)) {
            try {
                await putPAIAB020Toggle(seq);
                const { data } = await postPAIAB020List({ page });
                setData(data.data);
                setPages(data.info);
                window.alert(isPublic ? '비공개로 변경되었습니다.' : '공개로 변경되었습니다.');
            } catch (error) {
                console.error(error);
                window.alert(MESSAGE.notify.updateError);
            }
        }
    };

    const handleDelete = async (seq) => {
        const isConfirm = window.confirm(
            '삭제된 이력서는 복구가 불가능합니다.\n정말 삭제하시겠습니까?',
        );
        if (isConfirm) {
            try {
                await deletePAIAB020(seq);
                const { data } = await postPAIAB020List({ page });
                setData(data.data);
                setPages(data.info);
                window.alert(MESSAGE.notify.deleteSuccess);
            } catch (error) {
                console.error(error);
                window.alert(MESSAGE.notify.deleteError);
            }
        }
    };

    const handleDownload = (seq, fileName) => {
        setLoading(true);
        getPAIAB020Download(seq, fileName)
            .catch((error) => {
                console.error(error);
                window.alert(MESSAGE.notify.downloadError);
            })
            .finally(() => setLoading(false));
    };

    const handleJumpUp = async (seq) => {
        try {
            await putPAIAB020JumpUp(seq);
            const { data } = await postPAIAB020List({ page });
            alert('점프업되었습니다.');
            setData(data.data);
            setPages(data.info);
        } catch (error) {
            console.error(error);
            window.alert(MESSAGE.notify.updateError);
        }
    };

    const handleReset = async (seq) => {
        try {
            await putPAIAB020Reset(seq);
            const { data } = await postPAIAB020List({ page });
            setData(data.data);
            setPages(data.info);
        } catch (error) {
            console.error(error);
            window.alert(MESSAGE.notify.updateError);
        }
    };

    const handleClone = async (seq) => {
        try {
            await postPAIAB020Clone(seq);
            const { data } = await postPAIAB020List({ page });
            setData(data.data);
            setPages(data.info);
        } catch (error) {
            console.error(error);
            window.alert(MESSAGE.notify.updateError);
        }
    };

    const handlePopup = (seq) => {
        setActivePopup((prev) => (prev === seq ? null : seq));
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest('.rsm-mng__popup') && !event.target.closest('.rsm-mng__menu')) {
                setActivePopup(null);
            }
        };

        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    return (
        <>
            <div id="content" className="sub-page PAIAB020">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume">
                            <div className="resume__inner">
                                <h3 className="resume__tit">
                                    이력서 관리{' '}
                                    <span>
                                        * 이력서 공개 기간은 별도 제한이 없으며, 비공개를 원하시는 선생님께서는 별도로 비공개 설정 부탁드립니다.
                                    </span>
                                </h3>
                                <div className="rsm-mng">
                                    <div className="rsm-mng__btbx">
                                        <button
                                            type="button"
                                            className="rsm-mng__btn"
                                            onClick={() => navigate('/paiab010')}
                                        >
                                            이력서 등록
                                        </button>
                                    </div>
                                    <div className="rsm-mng__block">
                                        <table className="rsm-mng__table">
                                            <thead>
                                                <tr>
                                                    <th>등록일</th>
                                                    {/* <th>공개여부</th> */}
                                                    <th className="wd37">제목</th>
                                                    <th>
                                                        <div className="dntInf__stt-info">
                                                            Jump up
                                                            <img
                                                                src="./images/icons/icon-info-th.png"
                                                                alt="icon info"
                                                            />
                                                            <div className="tlt tlt--jump">
                                                                <div className="tlt__jump">
                                                                    <span>Jump Up 버튼을 클릭</span>하시면 뒤로 밀렸던
                                                                    회원님의 이력서가 인재소식 1페이지 첫번째 줄로
                                                                    이동합니다.
                                                                </div>
                                                                <div className="tlt__jump">
                                                                    <span>덴탈잡 모바일 앱</span>에에서도 Jump Up이
                                                                    가능하며, 하루에 여러번 Jump Up을 하시면 회원님의
                                                                    이력서가 구인치과/기공소에 노출될 확률이 높습니다!
                                                                </div>
                                                                <svg
                                                                    className="tlt__svg"
                                                                    width={28}
                                                                    height={16}
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    version="1.1"
                                                                >
                                                                    <polyline
                                                                        points="18 16 0 8 18 0"
                                                                        strokeWidth={1}
                                                                        stroke="#88abda"
                                                                        fill="#e6effa"
                                                                        paintOrder="fill"
                                                                    />
                                                                    <rect
                                                                        x={18}
                                                                        y={0}
                                                                        width={10}
                                                                        height={16}
                                                                        fill="#e6effa"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th>조회수</th>
                                                    <th>최종수정</th>
                                                    <th>관리</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data && data.length > 0 ? (
                                                    data.map((item) => (
                                                        <tr key={item.seq}>
                                                            <td>
                                                                <div className="rsm-mng__col">
                                                                    <span>{formatDate(item.addDate)}</span>
                                                                    <div
                                                                        onClick={() =>
                                                                            handleResumeLvl(item.seq, item.resumeLvl)
                                                                        }
                                                                        className={`rsm-mng__open ${item.resumeLvl === 'Y' ? 'active' : ''
                                                                            }`}
                                                                    >
                                                                        {item.resumeLvl === 'Y' ? '공개' : '비공개'}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            {/* <td style={{ width: '0px', visibility: 'hiden' }}>
                                                                <button
                                                                    type="button"
                                                                    className={`rsm-mng__toggle ${
                                                                        item.resumeLvl === 'Y' ? 'active' : ''
                                                                    }`}
                                                                    onClick={() => handleResumeLvl(item.seq)}
                                                                />
                                                            </td> */}
                                                            <td className="text-left">
                                                                <a
                                                                    style={{ fontSize: '17px' }}
                                                                    className="twoLine-text"
                                                                    rel="nofollow"
                                                                    target="_self"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        window.open(
                                                                            `/paiab020-${item?.seq}`,
                                                                            '_blank',
                                                                            `width=1200,height=${window.screen.height}`,
                                                                        );
                                                                    }}
                                                                >
                                                                    {item.title}
                                                                </a>
                                                            </td>
                                                            <td>
                                                                {item.resumeLvl === 'Y' ? (
                                                                    <div
                                                                        className="rsm-mng__jump-up"
                                                                        onClick={() => handleJumpUp(item.seq)}
                                                                    >
                                                                        Jump up
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </td>
                                                            <td>
                                                                <div className="dntInf__view">
                                                                    {item.visitedCnt}
                                                                    <button
                                                                        type="button"
                                                                        className="dntInf__reset"
                                                                        onClick={() => handleReset(item.seq)}
                                                                    >
                                                                        초기화
                                                                    </button>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className="rsm-mng__date">
                                                                    {formatDate(item.modDate)}
                                                                    <br />
                                                                    {moment(item.modDate)
                                                                        .locale('ko')
                                                                        .format('HH:mm:ss')}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="rsm-mng__btbx2">
                                                                    <div className="rsm-mng__lf">
                                                                        <button
                                                                            type="button"
                                                                            className="rsm-mng__btn2 rsm-mng__btn2--blue"
                                                                            onClick={() =>
                                                                                navigate(`/paiab010-${item.seq}`)
                                                                            }
                                                                        >
                                                                            <Link>수정</Link>
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="rsm-mng__btn2"
                                                                            onClick={() => handleClone(item.seq)}
                                                                        >
                                                                            복사
                                                                        </button>
                                                                    </div>
                                                                    <div
                                                                        className="rsm-mng__menu"
                                                                        onClick={() => handlePopup(item.seq)}
                                                                    >
                                                                        <i></i>
                                                                        <i></i>
                                                                        <i></i>
                                                                    </div>
                                                                    {activePopup === item.seq && (
                                                                        <div className="rsm-mng__popup">
                                                                            <ul>
                                                                                <li>
                                                                                    <button
                                                                                        onClick={() =>
                                                                                            handleDownload(
                                                                                                item.seq,
                                                                                                item.title,
                                                                                            )
                                                                                        }
                                                                                        disabled={loading}
                                                                                    >
                                                                                        {loading ? (
                                                                                            <p
                                                                                                style={{
                                                                                                    width: '120.63px',
                                                                                                }}
                                                                                            >
                                                                                                <Loader
                                                                                                    size={15}
                                                                                                    color="#0068b7"
                                                                                                />
                                                                                            </p>
                                                                                        ) : (
                                                                                            '워드파일로 다운로드'
                                                                                        )}
                                                                                    </button>
                                                                                </li>
                                                                                <li>
                                                                                    <button
                                                                                        onClick={() =>
                                                                                            handleDelete(item.seq)
                                                                                        }
                                                                                    >
                                                                                        삭제
                                                                                    </button>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={7} className="no-data">
                                                            데이터없습니다
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        <Pagination pages={pages} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default PAIAB020;
